import { setupFormState } from '@/components/form/tidal-form'
import { DriverAssignmentFormState } from './typings'

export const form = setupFormState<DriverAssignmentFormState>({
  id: 'driverAssignmentForm',
  initialValues: { assignments: {} },
})
